import React, { useEffect, useState, Fragment, useMemo, useRef } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import $ from "jquery";

import WrapperPerfil from "../../components/CentroProfile/WrapperPerfil";

import icon_prfile from "../../static/images/icon-prfile.png";
import useOnceEffect from "../../Hooks/useOnceEffect";
import { Url } from "../../utils/Url/Url";

function PerfilCentro({ reload }) {
  const [loading, setLoading] = useState(true);
  const [company, setcompany] = useState("");
  const [sectorList, setsectorList] = useState([]);
  const [show, setShow] = useState(false);
  const [showPerfil, setshowPerfil] = useState(false);
  const [flag, setflag] = useState(false);
  const [tab, settab] = useState(1);
  const [activeTab, setactiveTab] = useState("tab-about");

  const [departments, setDepartments] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);
  const [departmentId, setDepartmentId] = useState("");

  const userId = useMemo(() => localStorage.getItem("userId"), []);

  function CallTab(id, li) {
    settab(id);

    let act = document.getElementById(activeTab);
    let newActive = document.getElementById(li);

    act.classList.remove("profile__tabs--active");
    newActive.classList.add("profile__tabs--active");

    setactiveTab(li);
  }

  function ReloadData() {
    setflag(flag ? false : true);
  }

  function getMunicipality(id = 0) {
    if (id === 0) return;

    axios
      .get(`access/municipalities?department=${id}`)
      .then(({ data }) => setMunicipalities(data));

    setDepartmentId(id);
  }

  const onClose = () => setshowPerfil(false);

  useOnceEffect(() => {
    axios.get("access/sector-list").then((result) => {
      setsectorList(result.data);
    });

    axios.get("department-list").then(({ data }) => setDepartments(data));
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    axios.get("access/company/" + userId).then((result) => {
      if (!result.data.webSite) {
        setLoading(true);
        setShow(true);
        // Rendertab();
      } else {
        setcompany(result.data);
        setLoading(false);
      }
    });
  }, [flag, userId]);

  const ppBanner = {
    width: "100%",
    height: "100%",
  };

  const cover = { background: "none" };

  function GuardarPerfil(values) {
    const perfil = {
      ...values,
      aboutUs: "",
      companyId: 0,
      genderPoliciesUs: "",
      mission: "",
      valuesUs: "",
      departmentId,
      allies: values.allies ? 1 : 0,
    };

    axios
      .post("formacion/create", perfil)
      .then((result) => {
        if (result.status === 200) {
          setflag(true);
          setShow(false);
          toast.success("Se ha creado su perfil exitosamente", {
            duration: 6000,
          });
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      });
  }

  function ActualizarPerfil() {
    let banner = document.getElementById("profileImageUpdate");
    let formData = new FormData();
    let { companyProfileId } = company;

    formData.append("profileImage", banner.files[0]);

    axios
      .post(`access/create-companyphoto/${companyProfileId}`, formData)
      .then((result) => {
        if (result.status === 200) {
          reload();
          setflag(flag ? false : true);
          toast.success("Se ha actualizado su foto de perfil exitosamente", {
            duration: 6000,
          });
          $("#actualizar-perfil-modal").modal("hide");
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
          $("#actualizar-perfil-modal").modal("hide");
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
          $("#actualizar-perfil-modal").modal("hide");
        }
      });
  }

  function ActualizarPortada() {
    let banner = document.getElementById("bannerImageUpdate");

    let formData = new FormData();

    formData.append("bannerImage", banner.files[0]);

    let config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios
      .post(
        "access/create-companyphoto/" + company.companyProfileId,
        formData,
        config
      )
      .then((result) => {
        if (result.status === 200) {
          setflag(flag ? false : true);
          toast.success("Se ha actualizado su foto de portada exitosamente", {
            duration: 6000,
          });
          $("#actualizar-portada-modal").modal("hide");
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
          $("#actualizar-portada-modal").modal("hide");
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
          $("#actualizar-portada-modal").modal("hide");
        }
      });
  }

  function ActualizarDatosPerfil(values) {
    let perfil = {
      ...values,
      departmentId,
      companyId: company.companyProfileId,
      allies: values.allies ? 1 : 0,
    };

    axios
      .post("formacion/update", perfil)
      .then((result) => {
        if (result.status === 200) {
          setflag(flag ? false : true);
          setshowPerfil(false);
          toast.success("Se ha actualizado exitosamente", {
            duration: 6000,
          });
          $("#crear-acercade-modal").modal("hide");
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
          $("#crear-acercade-modal").modal("hide");
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
          $("#crear-acercade-modal").modal("hide");
        }
      });
  }

  const Validaciones = Yup.object().shape({
    name: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    employes: Yup.number().required("No puede estar vacio"),
    linkFacebook: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    linkInstagram: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    linkTwitter: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    slogan: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    ubication: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    webSite: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
  });

  return (
    <div className="vacantes perfil-empresa profile">
      <Fragment>
        <div className="container">
          <div className="row">
            <div className="body-profile">
              <div className="profile__header">
                <div className="profile__header-container">
                  <div className="profile__cover-photo" style={cover}>
                    <img
                      id="bannerPic"
                      src={company.coverImage}
                      className="no-cover-image"
                      alt="No cover"
                      style={ppBanner}
                    ></img>
                    <a
                      href="#/"
                      className="btn btn--white"
                      id="Editportada"
                      data-bs-toggle="modal"
                      data-bs-target="#actualizar-portada-modal"
                      data-title="Portada"
                    >
                      Editar Portada
                    </a>
                  </div>
                  <div className="profile__header-info">
                    <div className="profile__header-info-left">
                      <div className="profile__header-info-left-wrapper">
                        <div className="profile__header-info-photo">
                          <img
                            src={company.image}
                            style={{
                              maxHeight: "138px",
                              maxWidth: "135px",
                              width: "100%",
                              height: "100%",
                              borderRadius: "10px",
                            }}
                            alt="cover"
                          ></img>
                          <a
                            href="#/"
                            className="link"
                            data-bs-toggle="modal"
                            data-bs-target="#actualizar-perfil-modal"
                            data-title="Perfil"
                            style={{
                              position: "absolute",
                              left: "-20px",
                              bottom: "-55px",
                            }}
                          >
                            <img src={icon_prfile} alt="cover"></img>
                          </a>
                        </div>
                        <div className="profile__header-info-description">
                          <div className="profile__header-info-description-name">
                            {company.name}
                          </div>
                          <div className="profile__header-info-description-slogan">
                            {company.slogan}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="profile__header-info-right">
                      <div className="profile__header-info-right-wrapper">
                        <div className="profile__header-info-right-button">
                          <a
                            href="#/"
                            className="btn btn--gray"
                            onClick={() => setshowPerfil(true)}
                          >
                            <i className="fas fa-plus"></i> Editar Perfil
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="profile__tabs ">
                <div className="container bordered-box">
                  <div className="row">
                    <div className="col col-md-12">
                      <div className="profile__tabs-items">
                        <ul>
                          <li
                            id="tab-about"
                            className="profile__tabs--active"
                            onClick={() => CallTab(1, "tab-about")}
                          >
                            Acerca de Nosotros
                          </li>
                          <li
                            id="tab-empleo"
                            onClick={() => CallTab(2, "tab-empleo")}
                          >
                            Empleos
                          </li>
                          <li
                            id="tab-cursos"
                            onClick={() => CallTab(3, "tab-cursos")}
                          >
                            Formaciones
                          </li>
                          <li
                            id="tab-eventos"
                            onClick={() => CallTab(7, "tab-eventos")}
                          >
                            Eventos
                          </li>
                          <li
                            id="tab-fotos-videos"
                            onClick={() => CallTab(5, "tab-fotos-videos")}
                          >
                            Fotos / Videos
                          </li>
                          <li
                            id="tab-valoraciones"
                            onClick={() => CallTab(6, "tab-valoraciones")}
                          >
                            Buenas Practicas
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <label className="login-label">CARGANDO</label>
        ) : (
          <div className="container">
            <div className="row vacancy__content">
              <div className="col-12 col-md-5">
                <div className="vacancy__sidebar bordered-box mt-0">
                  <div className="bordered-box__header">
                    <div className="bordered-box__header-title">
                      Información
                    </div>
                  </div>
                  <div className="vacancy__sidebar-content">
                    <ul>
                      <li>
                        <strong>Sitio Web:</strong>{" "}
                        <a
                          href={Url(company.webSite)}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          {Url(company.webSite)}
                        </a>
                      </li>
                      <li>
                        <strong>Sector:</strong> {company.sectorId.name}
                      </li>
                      <li>
                        <strong>Dirección:</strong> {company.ubication}
                      </li>

                      <li>
                        <strong>Departamento:</strong>{" "}
                        {company?.departmentId?.name}
                      </li>

                      <li>
                        <strong>Municipio:</strong>{" "}
                        {company?.municipalityId?.name}
                      </li>

                      <li>
                        <strong>Año de Fundación:</strong> {company.fundation}
                      </li>
                      <li>
                        <strong>Empleados:</strong> {company.employes}
                      </li>
                    </ul>

                    <ul className="social-media">
                      {company.linkTwitter != "" ? (
                        <li>
                          <a href={Url(company.linkTwitter) ?? ""}>
                            <i className="fab fa-twitter-square"></i>
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {company.linkFacebook != "" ? (
                        <li>
                          <a href={Url(company.linkFacebook) ?? ""}>
                            <i className="fab fa-facebook-square"></i>
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {company.linkInstagram != "" ? (
                        <li>
                          <a href={Url(company.linkInstagram) ?? ""}>
                            <i className="fab fa-instagram-square"></i>
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <WrapperPerfil
                  id={tab}
                  company={company}
                  reload={ReloadData}
                ></WrapperPerfil>
              </div>
            </div>
          </div>
        )}

        <div
          id="actualizar-perfil-modal"
          className="kr-modal modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title"></div>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="form form--white ">
                  <div className="div__wrapper">
                    <div className="form__description text-center">
                      Seleccione una imagen
                    </div>
                    <div className="form__row">
                      <div className="col-sm-12 col-md-8">
                        <input
                          id="profileImageUpdate"
                          type="file"
                          required
                        ></input>
                      </div>
                    </div>
                    <div className="form__row">
                      <button
                        onClick={ActualizarPerfil}
                        className="btn btn--gradient btn__icon btn__icon--door"
                      >
                        Actualizar Perfil
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="actualizar-portada-modal"
          className="kr-modal modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title"></div>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="form form--white ">
                  <div className="div__wrapper">
                    <div className="form__description text-center">
                      Seleccione una imagen
                    </div>
                    <div className="form__row">
                      <div className="col-sm-12 col-md-8">
                        <input
                          id="bannerImageUpdate"
                          type="file"
                          required
                        ></input>
                      </div>
                    </div>
                    <div className="form__row">
                      <button
                        onClick={ActualizarPortada}
                        className="btn btn--gradient btn__icon btn__icon--door"
                      >
                        Actualizar Portada
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalPost
          {...{
            show,
            GuardarPerfil,
            Validaciones,
            sectorList,
            departmentId,
            getMunicipality,
            departments,
            municipalities,
          }}
        />

        <ModalPut
          showPerfil={showPerfil}
          onClose={onClose}
          company={company}
          Validaciones={Validaciones}
          sectorList={sectorList}
          departments={departments}
          municipalities={municipalities}
          getMunicipality={getMunicipality}
          ActualizarDatosPerfil={ActualizarDatosPerfil}
          departmentId={departmentId}
        />
      </Fragment>
    </div>
  );
}

function ModalPost({
  show,
  GuardarPerfil,
  Validaciones,
  sectorList,
  departmentId,
  getMunicipality,
  departments,
  municipalities,
}) {
  return (
    <>
      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        dialogClassName="kr-modal"
      >
        <Modal.Body>
          <div className="form form--white ">
            <Formik
              initialValues={{
                aboutUs: "",
                employes: "",
                fundation: "",
                genderPoliciesUs: "",
                linkFacebook: "",
                linkInstagram: "",
                linkTwitter: "",
                mission: "",
                name: "",
                sectorId: 0,
                slogan: "",
                ubication: "",
                valuesUs: "",
                webSite: "",
                departmentId: "",
                municipalityId: "",
                allies: false,
              }}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true);
                GuardarPerfil(values);
                setSubmitting(false);
              }}
              validationSchema={Validaciones}
            >
              {({ errors, touched, isSubmitting }) => (
                <Form>
                  <div className="div__wrapper">
                    <div className="form__title text-center">Crear Perfil</div>
                    <div className="form__row">
                      <div className="col-sm-12 mt-3">
                        <label htmlFor="webSite">Url Sitio Web</label>
                        <Field
                          type="text"
                          name="webSite"
                          id="webSite"
                          placeholder="https://tucentro.com"
                        ></Field>
                        {errors.webSite && touched.webSite && (
                          <span className="form__validation form__validation--error">
                            {errors.webSite}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 mt-3">
                        <label htmlFor="sectorId">Sector Empresarial</label>
                        <Field
                          as="select"
                          type="text"
                          name="sectorId"
                          id="sectorId"
                          required
                        >
                          {sectorList.map((item, index) => {
                            return (
                              <option key={index} value={item.sectorId}>
                                {item.name}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.sectorId && touched.sectorId && (
                          <span className="form__validation form__validation--error">
                            {errors.sectorId}
                          </span>
                        )}
                      </div>

                      <div className="col-sm-12 mt-3">
                        <label htmlFor="ubication">Dirección Principal</label>
                        <Field
                          type="text"
                          name="ubication"
                          id="ubication"
                          required
                        ></Field>
                        {errors.ubication && touched.ubication && (
                          <span className="form__validation form__validation--error">
                            {errors.ubication}
                          </span>
                        )}
                      </div>

                      <div className="col-12 mt-3">
                        <label>Departamento</label>

                        <Field
                          value={departmentId}
                          onChange={({ target: { value } }) =>
                            getMunicipality(parseInt(value))
                          }
                          as="select"
                          type="text"
                          name="departmentId"
                          id="departmentId"
                          required
                        >
                          <option hidden selected>
                            Seleccione un departamento
                          </option>

                          {departments.map((item, index) => (
                            <option key={index} value={item.departmentId}>
                              {item.name}
                            </option>
                          ))}
                        </Field>

                        {errors.departmentId && touched.departmentId && (
                          <span className="form__validation form__validation--error">
                            {errors.departmentId}
                          </span>
                        )}
                      </div>

                      <div className="col-12 mt-3">
                        <label>Municipio</label>

                        <Field
                          as="select"
                          type="text"
                          name="municipalityId"
                          id="municipalityId"
                          required
                        >
                          <option hidden selected>
                            Seleccione un Municipio
                          </option>

                          {municipalities.map((item, index) => (
                            <option key={index} value={item.municipalityId}>
                              {item.name}
                            </option>
                          ))}
                        </Field>

                        {errors.municipalityId && touched.municipalityId && (
                          <span className="form__validation form__validation--error">
                            {errors.municipalityId}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 mt-3">
                        <label htmlFor="employes">Empleados</label>
                        <Field
                          type="text"
                          name="employes"
                          id="employes"
                        ></Field>
                        {errors.employes && touched.employes && (
                          <span className="form__validation form__validation--error">
                            {errors.employes}
                          </span>
                        )}
                      </div>

                      <div className="col-sm-12 mt-3">
                        <label htmlFor="fundation">Año de Fundación</label>
                        <Field
                          type="text"
                          className="form-control"
                          name="fundation"
                          id="fundation"
                        ></Field>
                        {errors.fundation && touched.fundation && (
                          <span className="form__validation form__validation--error">
                            {errors.fundation}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 mt-3">
                        <label htmlFor="name">Nombre</label>
                        <Field
                          type="text"
                          name="name"
                          id="name"
                          required
                        ></Field>
                        {errors.name && touched.name && (
                          <span className="form__validation form__validation--error">
                            {errors.name}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 mt-3">
                        <label htmlFor="slogan">Eslogan</label>
                        <Field type="text" name="slogan" id="slogan"></Field>
                        {errors.slogan && touched.slogan && (
                          <span className="form__validation form__validation--error">
                            {errors.slogan}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 mt-3">
                        <label htmlFor="linkInstagram">Instagram</label>
                        <Field
                          type="text"
                          name="linkInstagram"
                          id="linkInstagram"
                          placeholder="https://instagram.com/perfil"
                        ></Field>
                        {errors.linkInstagram && touched.linkInstagram && (
                          <span className="form__validation form__validation--error">
                            {errors.linkInstagram}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 mt-3">
                        <label htmlFor="linkTwitter">Twitter</label>
                        <Field
                          type="text"
                          name="linkTwitter"
                          id="linkTwitter"
                          placeholder="https://twitter.com/perfil"
                        ></Field>
                        {errors.linkTwitter && touched.linkTwitter && (
                          <span className="form__validation form__validation--error">
                            {errors.linkTwitter}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 mt-3">
                        <label htmlFor="linkFacebook">Facebook</label>
                        <Field
                          type="text"
                          name="linkFacebook"
                          id="linkFacebook"
                          placeholder="https://facebook.com/perfil"
                        ></Field>
                        {errors.linkFacebook && touched.linkFacebook && (
                          <span className="form__validation form__validation--error">
                            {errors.linkFacebook}
                          </span>
                        )}
                      </div>

                      <div className="col-sm-12 mt-3">
                        <label htmlFor="allies">
                          <Field type="checkbox" name="allies" id="allies" />
                          &nbsp; Formar parte del programa aliados
                        </label>
                      </div>
                    </div>
                    <div className="form__row">
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--gradient btn__icon btn__icon--door"
                      >
                        Guardar
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

function ModalPut({
  showPerfil,
  onClose,
  company,
  ActualizarDatosPerfil,
  Validaciones,
  sectorList,
  departmentId,
  departments,
  municipalities,
  getMunicipality,
}) {
  const hasSubmit = useRef(false);

  useEffect(() => {
    if (company?.departmentId?.departmentId) {
      if (isNaN(parseInt(company?.departmentId?.departmentId))) {
        return;
      }

      getMunicipality(parseInt(company?.departmentId?.departmentId));
    }

    //eslint-disable-next-line
  }, [company]);

  useEffect(() => {
    if (!showPerfil) {
      getMunicipality(parseInt(company?.departmentId?.departmentId));
    }

    //eslint-disable-next-line
  }, [showPerfil]);

  return (
    <Modal
      show={showPerfil}
      onHide={onClose}
      keyboard={false}
      dialogClassName="kr-modal"
    >
      <Modal.Body>
        <div className="form form--white ">
          <Formik
            initialValues={{
              aboutUs: company.aboutUs,
              employes: company.employes,
              fundation: company.fundation,
              genderPoliciesUs: company.genderPoliciesUs,
              linkFacebook: company.linkFacebook,
              linkInstagram: company.linkInstagram,
              linkTwitter: company.linkTwitter,
              mission: company.mission,
              name: company.name,
              sectorId:
                company.sectorId === undefined ? 1 : company.sectorId.sectorId,
              slogan: company.slogan,
              ubication: company.ubication,
              valuesUs: company.valuesUs,
              webSite: company.webSite,
              departmentId: company?.departmentId?.departmentId,
              municipalityId: company?.municipalityId?.municipalityId,
              allies: company?.allies === 1,
            }}
            onSubmit={(values, { setSubmitting }) => {
              hasSubmit.current = true;
              setSubmitting(true);
              ActualizarDatosPerfil(values);
              setSubmitting(false);
            }}
            validationSchema={Validaciones}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form>
                <div className="div__wrapper">
                  <div className="form__title text-center">Crear Perfil</div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="webSite">Url Sitio Web</label>
                      <Field
                        type="text"
                        name="webSite"
                        id="webSite"
                        placeholder="https://tucentro.com"
                      ></Field>
                      {errors.webSite && touched.webSite && (
                        <span className="form__validation form__validation--error">
                          {errors.webSite}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="sectorId">Sector Empresarial</label>
                      <Field
                        as="select"
                        type="text"
                        name="sectorId"
                        id="sectorId"
                        required
                      >
                        {sectorList.map((item, index) => {
                          return (
                            <option key={index} value={item.sectorId}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                      {errors.sectorId && touched.sectorId && (
                        <span className="form__validation form__validation--error">
                          {errors.sectorId}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="ubication">Dirección Principal</label>
                      <Field
                        type="text"
                        name="ubication"
                        id="ubication"
                        required
                      ></Field>
                      {errors.ubication && touched.ubication && (
                        <span className="form__validation form__validation--error">
                          {errors.ubication}
                        </span>
                      )}
                    </div>

                    <div className="col-12 mt-3">
                      <label>Departamento</label>

                      <Field
                        value={departmentId}
                        onChange={({ target: { value } }) =>
                          getMunicipality(parseInt(value))
                        }
                        as="select"
                        type="text"
                        name="departmentId"
                        id="departmentId"
                        required
                      >
                        <option hidden selected>
                          Seleccione un departamento
                        </option>

                        {departments.map((item, index) => (
                          <option key={index} value={item.departmentId}>
                            {item.name}
                          </option>
                        ))}
                      </Field>

                      {errors.departmentId && touched.departmentId && (
                        <span className="form__validation form__validation--error">
                          {errors.departmentId}
                        </span>
                      )}
                    </div>

                    <div className="col-12 mt-3">
                      <label>Municipio</label>

                      <Field
                        as="select"
                        type="text"
                        name="municipalityId"
                        id="municipalityId"
                        required
                      >
                        <option hidden selected>
                          Seleccione un Municipio
                        </option>

                        {municipalities.map((item, index) => (
                          <option key={index} value={item.municipalityId}>
                            {item.name}
                          </option>
                        ))}
                      </Field>

                      {errors.municipalityId && touched.municipalityId && (
                        <span className="form__validation form__validation--error">
                          {errors.municipalityId}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="employes">Empleados</label>
                      <Field type="text" name="employes" id="employes"></Field>
                      {errors.employes && touched.employes && (
                        <span className="form__validation form__validation--error">
                          {errors.employes}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="fundation">Año de Fundación</label>
                      <Field
                        type="text"
                        className="form-control"
                        name="fundation"
                        id="fundation"
                      ></Field>
                      {errors.fundation && touched.fundation && (
                        <span className="form__validation form__validation--error">
                          {errors.fundation}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="genderPoliciesUs">
                        Políticas de Género
                      </label>
                      <Field
                        as="textarea"
                        name="genderPoliciesUs"
                        id="genderPoliciesUs"
                      ></Field>
                      {errors.genderPoliciesUs && touched.genderPoliciesUs && (
                        <span className="form__validation form__validation--error">
                          {errors.genderPoliciesUs}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="name">Nombre</label>
                      <Field type="text" name="name" id="name" required></Field>
                      {errors.name && touched.name && (
                        <span className="form__validation form__validation--error">
                          {errors.name}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="mission">Mision</label>
                      <Field type="text" name="mission" id="mission"></Field>
                      {errors.mission && touched.mission && (
                        <span className="form__validation form__validation--error">
                          {errors.mission}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="slogan">Eslogan</label>
                      <Field type="text" name="slogan" id="slogan"></Field>
                      {errors.slogan && touched.slogan && (
                        <span className="form__validation form__validation--error">
                          {errors.slogan}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="valuesUs">Valores</label>
                      <Field type="text" name="valuesUs" id="valuesUs"></Field>
                      {errors.valuesUs && touched.valuesUs && (
                        <span className="form__validation form__validation--error">
                          {errors.valuesUs}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="linkInstagram">Instagram</label>
                      <Field
                        type="text"
                        name="linkInstagram"
                        id="linkInstagram"
                        placeholder="https://instagram.com/perfil"
                      ></Field>
                      {errors.linkInstagram && touched.linkInstagram && (
                        <span className="form__validation form__validation--error">
                          {errors.linkInstagram}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="linkTwitter">Twitter</label>
                      <Field
                        type="text"
                        name="linkTwitter"
                        id="linkTwitter"
                        placeholder="https://twitter.com/perfil"
                      ></Field>
                      {errors.linkTwitter && touched.linkTwitter && (
                        <span className="form__validation form__validation--error">
                          {errors.linkTwitter}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="linkFacebook">Facebook</label>
                      <Field
                        type="text"
                        name="linkFacebook"
                        id="linkFacebook"
                        placeholder="https://facebook.com/perfil"
                      ></Field>
                      {errors.linkFacebook && touched.linkFacebook && (
                        <span className="form__validation form__validation--error">
                          {errors.linkFacebook}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form__row"></div>
                  <div className="form__row">
                    <label htmlFor="aboutUs">Acerca de mi</label>
                    <Field
                      as="textarea"
                      type="text"
                      name="aboutUs"
                      id="aboutUs"
                    ></Field>
                    {errors.aboutUs && touched.aboutUs && (
                      <span className="form__validation form__validation--error">
                        {errors.aboutUs}
                      </span>
                    )}
                  </div>

                  <div>
                    <label htmlFor="allies">
                      <Field type="checkbox" name="allies" id="allies" />
                      &nbsp; Formar parte del programa aliados
                    </label>
                  </div>

                  <div className="form__row">
                    <button
                      disabled={isSubmitting}
                      type="submit"
                      className="btn btn--gradient btn__icon btn__icon--door"
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default PerfilCentro;
